<header>
  <div class="govco-topbar">
    <a class="govco-mark" href="https://www.gov.co/" target="_blank" rel="noopener"><img src="assets/logo-govco.png" alt="GOV.CO" /></a>
    @if (auth.sessionChecked() && !auth.identity()?.authenticated) {
      <div class="user-area"><a routerLink="/inicio-sesion">Iniciar sesión</a></div>
    }
  </div>
  <div class="institutional-header">
    <a class="minambiente-header-logo" routerLink="/inicio" aria-label="Ministerio de Ambiente, ir a la portada"><img src="assets/brand-minambiente.png" alt="Ambiente - Ministerio de Ambiente y Desarrollo Sostenible" /></a>
    <a routerLink="/inicio" aria-label="Expertise France, ir a la portada"><img class="expertise-france-logo" src="assets/expertise-france.png" alt="Expertise France, Groupe AFD" /></a>
  </div>
  <div class="accessibility-menu" [class.open]="accessibility.open()" aria-label="Herramientas de accesibilidad">
    <button type="button" (click)="accessibility.toggle()" [attr.aria-expanded]="accessibility.open()" aria-label="Abrir menú de accesibilidad">☼</button>
    @if (accessibility.open()) {
      <button type="button" (click)="setScale(-1)" aria-label="Disminuir tamaño del texto">A−</button>
      <button type="button" (click)="setScale(1)" aria-label="Aumentar tamaño del texto">A+</button>
      <button type="button" (click)="toggleContrast()" aria-label="Activar alto contraste">◐</button>
    }
  </div>
</header>
